import { css } from "@emotion/react";

import { dimensions, helpers } from "@styles";

export const numberOfColumns = columnCount => css`
  column-count: ${columnCount};

  @media only screen and (max-width: ${dimensions.tabletMax}) {
    column-count: 3;
  }

  @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
    column-count: 2;
  }

  @media only screen and (max-width: ${dimensions.phoneMax}) {
    column-count: 1;
  }
`;

export const trayColumnItem = css`
  margin-bottom: 1rem;
  ${helpers.ellipsesOverflowHelper};
`;
